import React from "react";
import EntityType from "../EntityType";
import SuggestionsPicker from "./SuggestionsPicker";
import GenericSuggestionsPickerProps from "./GenericSuggestionsPickerProps";
import PeoplePickerSelected from "./suggestionsPickerSelected/PeoplePickerSelected";
import { buildGetItemUrl, buildSuggestItem } from "./utils/peoplePickerUtils";
import { AutoSuggestItem } from "../AutoSuggestResponse";

const suggestId = (data: AutoSuggestItem) => data.urlId;

/**
 * Reusable people picker component.
 *
 * @param {*} props
 * @returns {JSX.Element}
 */
const PeoplePicker: React.FC<GenericSuggestionsPickerProps> = (
  props
): JSX.Element => {
  return (
    <SuggestionsPicker
      {...props}
      buildGetItemUrl={buildGetItemUrl}
      buildSuggestItem={buildSuggestItem}
      getIdFromSuggestItem={suggestId}
      suggestionTypes={[EntityType.EMPLOYEE]}
      suggestionsSelectedComponent={PeoplePickerSelected}
    />
  );
};

export default PeoplePicker;
